var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExamActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1453_12944)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4866 1.94336H3.62946C3.02326 1.94336 2.44187 2.18418 2.01322 2.61283C1.58457 3.04148 1.34375 3.62286 1.34375 4.22907V29.3719C1.34375 29.9781 1.58457 30.5595 2.01322 30.9882C2.44187 31.4168 3.02326 31.6576 3.62946 31.6576H24.2009C24.8071 31.6576 25.3885 31.4168 25.8171 30.9882C26.2458 30.5595 26.4866 29.9781 26.4866 29.3719V19.0862",
    stroke: "#1377D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.34375 24.7998H26.4866",
    stroke: "#1377D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.2002 7.6582H12.7716",
    stroke: "#1377D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.2002 13.3721H10.4859",
    stroke: "#1377D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7585 17.9566L13.9014 19.1909L15.0442 12.2423L24.7128 2.61947C24.9253 2.40523 25.1781 2.23519 25.4566 2.11915C25.7352 2.0031 26.0339 1.94336 26.3357 1.94336C26.6374 1.94336 26.9362 2.0031 27.2147 2.11915C27.4932 2.23519 27.746 2.40523 27.9585 2.61947L30.3814 5.04233C30.5962 5.2545 30.7667 5.5072 30.8831 5.78578C30.9995 6.06436 31.0594 6.36327 31.0594 6.66518C31.0594 6.9671 30.9995 7.26601 30.8831 7.54459C30.7667 7.82316 30.5962 8.07587 30.3814 8.28804L20.7585 17.9566Z",
    stroke: "#1377D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1453_12944"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.200195 0.799805)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExamActiveIcon);
export default __webpack_public_path__ + "static/media/exam-active-icon.24216b6640f9f5567a8b416aa467700d.svg";
export { ForwardRef as ReactComponent };